<base-modal [title]="title" [isProfileMode]="true">
  <div *ngIf="users">
    <div>{{ body }}</div>
    <ul *ngFor="let user of users">
      <li>{{ user.name.firstName }} {{ user.name.lastName }} <i>({{ emailLookup[user._id] }})</i></li>
    </ul>
  </div>
  <nv-button (clickButton)="closeModal()">Close</nv-button>
</base-modal>